import { Button, Select, Card, Typography, Space, Form, message } from "antd";
import React, { useState, useEffect } from "react";
import AboutElectionsUpload from "./AboutElectionsUpload";
import dataService from "../../networks/api/service/dataService";

const { Option } = Select;
const { Title } = Typography;

function AboutConstituency() {
  const [constituencyList, setConstituencyList] = useState([]);
  const [constituencyId, setConstituencyId] = useState("");
  const [extractedData, setExtractedData] = useState(null);

  const OnConstituencySelect = async (value) => {
    setConstituencyId(value);
  };

  const handleFileData = (data) => {
    setExtractedData(data);
  };

  const handleSubmit = () => {
    if (!constituencyId) {
      alert("Please select all fields and upload a file");
      return;
    }

    const payload = {
      constituency: constituencyId,
      geogrophicalArea: extractedData.geographicalArea,
      electedCandidate: extractedData.electedCandidate,
      MAP: "images",
    };
    uploadData(payload);
    console.log("Final Payload:", payload);
  };

  const uploadData = async (payload) => {
    const response = await dataService.constituencyAboutUpload(payload);
    if (response.code === 200) {
      message.success("Data uploaded successfully");
    } else {
    }
  };

  const getConstituency = async () => {
    try {
      const res = await dataService.getAllConstituency();
      if (res.code === 200) setConstituencyList(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
  }, []);

  return (
    <Card
      title={
        <Title level={4} style={{ textAlign: "center" }}>
          About Constituency Elections
        </Title>
      }
      style={{ width: "100%", maxWidth: 800, margin: "auto", padding: 20 }}
    >
      <Form layout="vertical" style={{ width: "100%" }}>
        <Form.Item label="Select Parliament">
          <Select
            value={constituencyId}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select Parliament"
            style={{ width: "100%" }}
            onChange={OnConstituencySelect}
          >
            {constituencyList.map((item) => (
              <Option key={item._id} value={item._id}>
                {item.constituencyName}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Upload Election Data">
          <AboutElectionsUpload onDataExtracted={handleFileData} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" onClick={handleSubmit} block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default AboutConstituency;
